var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms"},[_c('SanitasTerms',{attrs:{"back-link":_vm.backLink,"content-base-url":_vm.contentBaseUrl,"api-base-url":_vm.baseDomain,"language":_vm.language}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }